import styled from 'styled-components';

export const FieldInputTitle = styled.div`
  color: ${(props) => props.theme.colors.muted};
`;

export const FullWideContentBlock = styled.div<{ extraRight: boolean }>`
  width: 100%;
  ${(props) => props.extraRight && 'max-width: 416px;'}
`;
